import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBasketSuccessBanner = styled(Box)(({theme}) => ({
  background: theme.palette.success.light,
  padding: theme.spacing(1, 2, 1, 2),
  textAlign: 'center'
}));

export const StyledBasketPromotionBanner = styled(Box)(({theme}) => ({
  background: theme.palette.common.mds_global_color_purple_light_50,
  padding: theme.spacing(1, 2, 1, 2),
  textAlign: 'center'
}));

export const StyledBasketDangerBanner = styled(StyledBasketSuccessBanner)(({theme}) => ({
  background: theme.palette.common.mds_global_color_red_15
}));

export const StyledBasketInfoBanner = styled(Box)(({theme}) => ({
  background: '#EBF9FF',
  padding: theme.spacing(1, 2, 1, 2),
  textAlign: 'center',
  color: '#1274E6'
}));
